<template>
    <div>
        <b-nav-form method="get" target="_blank" class="lx-header-search" @submit.prevent="onSubmit">
            <input
                name="q"
                ref="input"
                type="text"
                class="form-control"
                aria-label="Search"
                :value="inputValue"
                @focus="onFocus"
                @blur="onBlur"
                @input="onInput($event.target.value)"
                autocomplete="off"
                placeholder="Search"
            />
            <header-search-list
                ref="list"
                :show="showResults"
                :query="inputValue"
                :data="searchResults"
            ></header-search-list>
        </b-nav-form>
    </div>
</template>

<script>
    import HeaderSearchList from './header-search-list.vue';
    import API from '../../../api';
    import debounce from 'lodash/debounce';

    export default {
        name: 'HeaderSearch',
        components: {
            HeaderSearchList,
        },
        data() {
            return {
                isFocused: false,
                inputValue: '',
                searchResults: [],
            };
        },
        methods: {
            onFocus() {
                this.isFocused = true;
            },
            onBlur(event) {
                if (this.showResults && !event.sourceCapabilities) {
                    // On iPad when onscreen keyboard is hidden, input element looses focus.
                    // This should set focus on popup to leave it open when onscreen keyboard is closed.
                    this.$refs.list.$el.focus();
                }
                setTimeout(() => (this.isFocused = false), 0);
            },
            onInput(newValue) {
                this.inputValue = newValue;
            },
            onSubmit() {
                this.$refs.input.focus();
            },
            async doSearch(query) {
                const response = await API.get(`/app/header/search/?q=${query}`);
                this.searchResults = response.data || [];
            },
        },
        computed: {
            showResults() {
                return this.isFocused && this.inputValue.length > 0 && this.searchResults.length > 0;
            },
        },
        watch: {
            inputValue: debounce(function (val) {
                val = val.trim();
                if (val) {
                    this.doSearch(val);
                } else if (this.searchResults.length) {
                    this.searchResults = [];
                }
            }, 500),
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .lx-header-search {
        position: relative;
    }

    /*
      Overwriting bootstrap style
     */
    :deep(.form-control, .form-control:active, .form-control:focus, .form-control:hover) {
        border: none !important;
        border-bottom: 1px solid #ffffff !important;
        border-radius: 0 !important;
        padding: 0.6rem 0 0.4rem 0 !important;
        background-color: transparent !important;
        color: #ffffff;
        outline: none !important;
        box-shadow: none !important;
        font-size: 1rem !important;
    }

    :deep(.form-control:focus) {
        border-bottom: 2px solid #4285f4 !important;
        color: #fff;
    }

    :deep(.form-control::placeholder) {
        color: #ffffff;
        font-size: 1rem !important;
    }

    :deep(.form-control:focus::placeholder) {
        color: transparent;
    }

    @include media-breakpoint-down(md) {
        :deep(.form-inline .form-control) {
            width: 100%;
        }
    }
</style>
